import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Popover from '@material-ui/core/Popover';
// import Typography from '@material-ui/core/Typography';
// import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import Paper from '@material-ui/core/Paper';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import wheelIcon from '../../assets/svg/wheel.svg';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import SearchIcon from '@material-ui/icons/Search';
import { useHistory } from 'react-router-dom';
import UsersDialog from '../Dialog/UsersDialog/UsersDialog';
import { Divider } from '@material-ui/core';
import FunctionsIcon from '@material-ui/icons/Functions';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(0),
    width: 250,
  },
}));

export default function ManageUser() {
  const classes = useStyles();
  const history = useHistory();
  const [anchorEl, setAnchorEl] = useState(null);
  const [userDialog, setUserDialog] = useState(false);
  const [calcDialog, setCalcDialog] = useState(false);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleAddCustomer = () => {
    handleClose();
    history.push('/protected/admin/users/add/customer');
  };
  const handleAddDriver = () => {
    handleClose();
    history.push('/protected/admin/users/add/driver');
  };
  const handleOpenUserDialog = () => {
    handleClose();
    setUserDialog(true);
  };
  const handleCloseUserDialog = () => {
    setUserDialog(false);
  };
  const handleSelectUser = ([user]) => {
    if (user?.role?.length) {
      history.push(`/protected/admin/users/${user?.role?.[0]}/${user?._id}`);
    }
  };
  const handleCalculatePrice = () => {
    handleClose();
    history.push('/protected/admin/calculations/basePrice');
  };

  return (
    <div>
      <UsersDialog
        single
        onChange={handleSelectUser}
        open={userDialog}
        closeDialog={handleCloseUserDialog}
      />
      <IconButton color="inherit" onClick={handleClick}>
        <AccountCircleIcon />
      </IconButton>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <Paper className={classes.paper}>
          <List>
            <ListItem button onClick={handleOpenUserDialog}>
              <ListItemIcon>
                <SearchIcon />
              </ListItemIcon>
              <ListItemText primary="جستجو کاربر" />
            </ListItem>
            <ListItem button onClick={handleAddCustomer}>
              <ListItemIcon>
                <PersonAddIcon />
              </ListItemIcon>
              <ListItemText primary="افزودن صاحب‌بار" />
            </ListItem>
            <ListItem button onClick={handleAddDriver}>
              <ListItemIcon>
                <img src={wheelIcon} height={24} width={24} alt="" />
              </ListItemIcon>
              <ListItemText primary="افزودن راننده" />
            </ListItem>
            <Divider />
            <ListItem button onClick={handleCalculatePrice}>
              <ListItemIcon>
                <FunctionsIcon />
              </ListItemIcon>
              <ListItemText primary="محاسبه کرایه" />
            </ListItem>
          </List>
        </Paper>
      </Popover>
    </div>
  );
}
